import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgxMaskModule } from 'ngx-mask';
import { TranslateModule } from '@ngx-translate/core';

import { PermissionsModule } from '../permissions';
import { AddBreakComponent } from './add-break.component';

@NgModule({
  declarations: [AddBreakComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    MatButtonModule,
    MatIconModule,
    NgxMaskModule,
    PermissionsModule,
  ],
  exports: [AddBreakComponent],
})
export class AddBreakModule {}
